(() => {
  if (window.PocketPairings) return;
  let library, rules = [], cart = null, cards = new Map();
  const parse = node => { try { return JSON.parse(node?.textContent || 'null'); } catch { return null; } };
  const cartIds = () => new Set((cart?.items || []).map(item => String(item.product_id || item.product?.id)).filter(id => id !== 'undefined'));
  const template = id => cards.get(String(id));
  function matches(sources, exclude) {
    const ids = [], seen = new Set(exclude);
    rules.forEach(rule => {
      if (!rule.sources.some(id => sources.has(String(id)))) return;
      rule.matches.forEach(id => {
        const key = String(id);
        if (!seen.has(key) && template(key)) { ids.push(key); seen.add(key); }
      });
    });
    return ids;
  }
  function variants(card) { return parse(card.querySelector('[data-pairing-variants]')) || []; }
  function selectVariant(card, variant) {
    const button = card.querySelector('button[name="id"]'), quantity = card.querySelector('[name="quantity"]');
    const valid = variant?.available && (variant.max == null || variant.max >= variant.min);
    button.disabled = !valid;
    button.value = variant ? String(variant.id) : '';
    button.dataset.quantity = String(variant?.min || 1);
    button.dataset.increment = String(variant?.increment || 1);
    button.dataset.max = variant?.max || '';
    quantity.value = String(variant?.min || 1);
    if (variant) {
      card.dataset.pairingPrice = String(variant.price);
      card.querySelector('[data-pairing-price-label]').textContent = variant.priceLabel;
      const choice = card.querySelector('[data-pairing-choice]');
      if (choice) choice.textContent = variant.options.join(' / ');
      const fallback = card.querySelector('[data-pairing-variant]');
      if (fallback) fallback.value = String(variant.id);
    }
    const status = card.querySelector('.quick-status');
    status.textContent = valid ? '' : library.dataset.unavailable;
    status.setAttribute('role', valid ? 'status' : 'alert');
  }
  function prepareCard(card) {
    if (card.dataset.pairingReady) return;
    card.dataset.pairingReady = 'true';
    const list = variants(card), selected = list.find(v => String(v.id) === card.querySelector('button[name="id"]').value) || list.find(v => v.available);
    const selects = [...card.querySelectorAll('[data-pairing-option]')];
    if (selects.length && selected) {
      selects.forEach((select, index) => {
        select.value = selected.options[index];
        [...select.options].forEach(option => {
          const available = list.some(v => v.available && v.options[index] === option.value);
          option.disabled = !available;
          if (!available) option.textContent += ' — ' + library.dataset.soldOut;
        });
      });
      card.querySelector('[data-pairing-fallback]').hidden = true;
      card.querySelector('[data-pairing-fields]').hidden = false;
    }
    if (selected) selectVariant(card, selected);
  }
  function panel(slot, heading, message, ids, limit) {
    slot.hidden = !ids.length;
    if (slot.hidden) { slot.replaceChildren(); return; }
    slot.classList.add('pairings-panel');
    let list = slot.querySelector('.pairings-list');
    if (!list) {
      if (!slot.hasAttribute('data-pairings-integrated')) {
        const title = document.createElement('h2'); title.className = 'pairings-heading';
        const subtitle = document.createElement('p'); subtitle.className = 'pairings-message';
        slot.append(title, subtitle);
      }
      list = document.createElement('div'); list.className = 'pairings-list';
      slot.append(list);
    }
    slot.setAttribute('aria-label', heading);
    const title = slot.querySelector('.pairings-heading');
    if (title) title.textContent = heading;
    const subtitle = slot.querySelector('.pairings-message');
    if (subtitle) { subtitle.textContent = message || ''; subtitle.hidden = !message; }
    const wanted = ids.slice(0, limit);
    const existing = new Map([...list.children].map(node => [node.dataset.productId, node]));
    existing.forEach((node, id) => { if (!wanted.includes(id)) node.remove(); });
    wanted.forEach(id => {
      let card = existing.get(id);
      if (!card) card = template(id)?.content.firstElementChild?.cloneNode(true);
      if (!card) return;
      list.append(card); prepareCard(card);
    });
  }
  function update() {
    if (!library) return;
    const inCart = cartIds(), position = library.dataset.productPosition || 'purchase';
    document.querySelectorAll('[data-product-pairings-slot]').forEach(slot => {
      const productId = slot.dataset.sourceProductId;
      const excluded = new Set([...inCart, productId]);
      const ids = library.dataset.productEnabled === 'true' && slot.dataset.pairingsPosition === position ? matches(new Set([productId]), excluded) : [];
      panel(slot, library.dataset.productHeading, '', ids, Number(library.dataset.productLimit) || 2);
    });
    document.querySelectorAll('[data-shipping-pairings]').forEach(slot => {
      const progress = slot.closest('[data-cart-section]')?.querySelector('[data-free-shipping]');
      const limit = Number(progress?.dataset.shippingLimit), total = Number(cart?.total_price), gap = limit - total;
      if (progress && library.dataset.cartHeading) {
        progress.dataset.headingPending = library.dataset.cartHeading;
        if (gap > 0) progress.querySelector('[data-shipping-heading]').textContent = library.dataset.cartHeading;
      }
      const currency = typeof cart?.currency === 'string' ? cart.currency : cart?.currency?.iso_code;
      const eligible = library.dataset.cartEnabled === 'true' && library.dataset.country === 'US' && currency === 'USD' && cart?.item_count > 0 && cart?.requires_shipping !== false && progress && !progress.hidden && gap > 0 && gap <= Number(library.dataset.nearLimit);
      const ids = eligible ? matches(inCart, inCart) : [];
      const prices = id => {
        const available = variants(template(id).content.firstElementChild).filter(v => v.available);
        return Math.min(...available.map(v => Number(v.price) * (Number(v.min) || 1)));
      };
      ids.sort((a, b) => {
        const pa = prices(a), pb = prices(b), aCovers = pa >= gap, bCovers = pb >= gap;
        if (aCovers !== bCovers) return aCovers ? -1 : 1;
        return aCovers ? pa - pb : pb - pa;
      });
      const amount = eligible ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(gap / 100) : '';
      const message = (library.dataset.cartMessage || '').replace('{amount}', amount);
      panel(slot, library.dataset.cartHeading, message, ids, Number(library.dataset.cartLimit) || 2);
    });
  }
  function load() {
    library = document.querySelector('[data-pairings-library]');
    if (!library) return;
    rules = parse(library.querySelector('[data-pairing-rules]')) || [];
    cards = new Map([...library.querySelectorAll('[data-pairing-template]')].map(node => [node.dataset.pairingTemplate, {content:node.content.cloneNode(true)}]));
    if (!cart) cart = parse(library.querySelector('[data-pairing-cart]'));
    update();
  }
  document.addEventListener('change', event => {
    const card = event.target.closest('[data-pairing-card]');
    if (!card || card.querySelector('form').dataset.busy) return;
    const list = variants(card);
    if (event.target.matches('[data-pairing-option]')) {
      const options = [...card.querySelectorAll('[data-pairing-option]')].map(select => select.value);
      selectVariant(card, list.find(variant => variant.options.every((value, index) => value === options[index])));
    } else if (event.target.matches('[data-pairing-variant]')) {
      selectVariant(card, list.find(variant => String(variant.id) === event.target.value));
    }
  });
  document.addEventListener('pocket:cart-updated', event => { cart = event.detail.cart; update(); });
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-pairings-library]')) { cart = null; load(); } else update();
  });
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    const rule = rules.find(rule => rule.id === id);
    if (!rule) return;
    const source = document.querySelector('[data-product-pairings-slot]')?.dataset.sourceProductId;
    if (rule.sources.some(value => String(value) === source)) document.querySelector('[data-product-pairings-slot]:not([hidden])')?.scrollIntoView({block:'center',behavior:'smooth'});
  });
  window.PocketPairings = {update};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load, {once:true}); else load();
})();
